/**
 * @description 会员重构菜单整理
 * */
export default function (menuList) {
  var str1 = JSON.stringify(menuList);
  var str2 = str1.replace(/children/g, 'subMenus');
  var str3 = str2.replace(/menuUrl/g, 'url');
  var str4 = str3.replace(/openType/g, 'isVue');
  var menus = JSON.parse(str4);
  console.log(menus, 'menus');
  return menus;
}